module.exports = __webpack_public_path__ + "img/search.c58aa44e.svg";